import { __extends } from "tslib";
import { warning } from '@awayfl/swf-loader';
import { EventDispatcher } from '../events/EventDispatcher';
import { Errors } from '@awayfl/avm2';
import { TimerEvent } from '../events/TimerEvent';
// Class: Timer
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer(delay, repeatCount /*int = 0 */) {
        var _this = _super.call(this) || this;
        _this._delay = +delay;
        _this._repeatCount = repeatCount | 0;
        _this._iteration = 0;
        return _this;
    }
    Object.defineProperty(Timer.prototype, "running", {
        get: function () {
            return this._running;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "delay", {
        get: function () {
            return this._delay;
        },
        set: function (value) {
            value = +value;
            if (value < 0 || !isFinite(value)) {
                this.sec.throwError('RangeError', Errors.DelayRangeError);
            }
            this._delay = value;
            if (this._running) {
                this.stop();
                this.start();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "repeatCount", {
        get: function () {
            return this._repeatCount;
        },
        set: function (value) {
            this._repeatCount = value | 0;
            if (this._repeatCount && this._running && this._iteration >= this._repeatCount) {
                this.stop();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timer.prototype, "currentCount", {
        get: function () {
            return this._iteration;
        },
        enumerable: true,
        configurable: true
    });
    Timer.prototype.reset = function () {
        if (this._running) {
            this.stop();
        }
        this._iteration = 0;
    };
    Timer.prototype.stop = function () {
        this._running = false;
        window.clearInterval(this._interval);
    };
    Timer.prototype.start = function () {
        if (this._running) {
            return;
        }
        this._running = true;
        this._interval = window.setInterval(this._tick.bind(this), this._delay);
    };
    Timer.prototype._tick = function () {
        this._iteration++;
        if (!this._running) {
            return;
        }
        if (Timer.dispatchingEnabled) {
            //enterTimeline("Timer.Timer");
            try {
                this.dispatchEvent(new this.sec.flash.events.TimerEvent('timer', true, false));
            }
            catch (e) {
                warning('caught error under Timer TIMER event: ', e);
            }
            //leaveTimeline();
        }
        if (this._repeatCount !== 0 && this._iteration >= this._repeatCount) {
            this.stop();
            //enterTimeline("Timer.TimerComplete");
            try {
                this.dispatchEvent(new this.sec.flash.events.TimerEvent(TimerEvent.TIMER_COMPLETE, false, false));
            }
            catch (e) {
                warning('caught error under Timer COMPLETE event: ', e);
            }
            //leaveTimeline();
        }
    };
    Timer.classInitializer = null;
    Timer.classSymbols = null; // [];
    Timer.instanceSymbols = null;
    /**
   * This lets you toggle timer event dispatching which is useful when trying to profile other
   * parts of the system.
   */
    Timer.dispatchingEnabled = true;
    return Timer;
}(EventDispatcher));
export { Timer };
